import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    transferenciasProveedores: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.transferenciasProveedores = [];
    },
    'SET_TRANSFERENCIAS_PROVEEDORES'(state, transferenciasProveedores) {
        state.transferenciasProveedores = transferenciasProveedores;

        state.transferenciasProveedores = [];
        for(let key in transferenciasProveedores) {
            const transferencia = transferenciasProveedores[key];
            let transferenciaProveedor = {
                id: transferencia.id,
                fechaCreditoDebito: transferencia.fechaCreditoDebito,
                bancoCuenta: transferencia.bancoCuenta,
                numero: transferencia.numero,
                importe: transferencia.importe,
                selected: Boolean(false)
            }
            state.transferenciasProveedores.push(transferenciaProveedor);
        }             
    },
    'SET_TRANSFERENCIAS_SELECCIONADAS'(state, transferenciasSeleccionados) {
        if (transferenciasSeleccionados.length != 0) {
            for(let key in state.transferenciasProveedores) {
                let transferencia = state.transferenciasProveedores[key];
                if (transferenciasSeleccionados.some(tr => tr.id == transferencia.id )) {
                    transferencia.selected = true;
                }
            }
        }
    },
};

const actions = {
    getTransferenciasDisponibles: ( {commit}, transferenciasSeleccionadas) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            let queryString = '';
            
            apiAxios.get('bancosmovimientos/transferenciasproveedores' + queryString)
                .then(res => {
                    commit('SET_TRANSFERENCIAS_PROVEEDORES', res.data)

                    if (transferenciasSeleccionadas) {
                        if (transferenciasSeleccionadas != null) {
                            commit('SET_TRANSFERENCIAS_SELECCIONADAS', transferenciasSeleccionadas);
                        }
                    }

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    transferenciasProveedoresSeleccionadas(state) {
        let seleccionadas = [];
        if (state.transferenciasProveedores.length != 0) {
            seleccionadas = state.transferenciasProveedores
                .filter( tp => (/true/i).test(tp.selected) == Boolean(true));
        }
        return seleccionadas;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}